import { applyMiddleware, compose, createStore } from 'redux'

import reducer from './reducers/index'
import thunk from 'redux-thunk'

const composeEnhancers = compose
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)))

export default store
